import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { CiPlay1 } from "react-icons/ci";
import '../styles/PlayVideo.css'

export const PlayVideo = () => {
    const [showModal, setShowModal] = useState(false);

    const handleCardClick = () => {
        setShowModal(true);
      };
    
    const handleClose = () => setShowModal(false);
    
  return (
    <div className="img-container" style={{ marginTop: "0", padding: "100px 20px" }}>
      {/* Background Video */}
      <img src='/assets/images/background.jpg' alt='background' className="img-background"/>

      {/* Content Overlay */}
      <div className="img-content">
        <div className="img-btn-wrap" onClick={() => handleCardClick()}>
          <a href="#home" class="img-btn"><CiPlay1/></a>
        </div>
      </div>

      <Modal show={showModal} onHide={handleClose} fullscreen variant="dark">
        <Modal.Body style={{maxWidth: '1200px',width:'90%',height:'400px'}}>
          {(
            <div className="d-flex justify-content-center align-items-center"
            style={{ height: '100%', marginLeft:'250px' }}>
              <iframe width="1100" height="500" src="https://www.youtube.com/embed/4b013QoA4so?si=XsqOQqBphnaGYP_G" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
